const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';

export interface ContactSubmissionInput {
    name: string;
    email: string;
    message: string;
    accessKey: string;
    altchaPayload: string;
}

interface Web3FormsResponse {
    success?: boolean;
    message?: string;
}

/**
 * Sends a contact message to Web3Forms.
 *
 * Security notes:
 * - The Web3Forms access key is intentionally public and must be provided via
 *   Vite env (`VITE_WEB3FORMS_ACCESS_KEY`).
 * - ALTCHA widget payload is required to reduce bot submissions.
 */
export async function submitContactMessage(input: ContactSubmissionInput): Promise<void> {
    const payload = {
        access_key: input.accessKey,
        name: input.name,
        email: input.email,
        message: input.message,
        subject: 'startzone.dev contact form',
        from_name: 'startzone.dev',
        altcha: input.altchaPayload,
        botcheck: '',
    };

    const response = await fetch(WEB3FORMS_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify(payload),
    });

    const data = (await response.json().catch(() => ({}))) as Web3FormsResponse;
    if (!response.ok || !data.success) {
        throw new Error(data.message || 'Unable to send message right now. Please try again soon.');
    }
}

